(function () {
  'use strict';

  const CONFIG = {
    swiperSelector: '.product-video-swiper-unique',
    slideSelector: '.product-video-slide-unique',
    overlaySelector: '#video-overlay',
    containerSelector: '.video-container',
    closeButtonSelector: '.close-video',
    slidesPerView: 3.5,
    spaceBetween: 12,
    initDelay: 100,
  };

  function initGifCarousel() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initGifCarousel, 200);
      return;
    }

    const swiperEl = document.querySelector(CONFIG.swiperSelector);
    if (!swiperEl) return;


    const wrapper = document.querySelector('.video-carousel-unique');
    if (wrapper) {
      const margin = wrapper.getAttribute('data-margin-bottom');
      if (margin) {
        wrapper.style.setProperty('--video-margin-bottom', `${margin}px`);
      }
    }


    if (swiperEl.swiper) {
      console.log('Swiper already initialized, attaching handlers');
      attachGifHandlers();
      setupLazyLoading();
      return;
    }


    const swiper = new Swiper(CONFIG.swiperSelector, {
      slidesPerView: CONFIG.slidesPerView,
      spaceBetween: CONFIG.spaceBetween,
      navigation: {
        nextEl: '.swiper-button-next-video-unique',
        prevEl: '.swiper-button-prev-video-unique',
      },
      on: {
        init: () => {
          setTimeout(() => {
            attachGifHandlers();
            setupLazyLoading();
          }, CONFIG.initDelay);
        },
      },
    });
  }

  function setupLazyLoading() {
    const slides = document.querySelectorAll(CONFIG.slideSelector);
    
    slides.forEach((slide) => {
      const img = slide.querySelector('.video-preview-unique img');
      if (!img) return;


      slide.classList.add('gif-loading');


      if (img.complete && img.naturalHeight !== 0) {

        slide.classList.remove('gif-loading');
        slide.classList.add('gif-loaded');
      } else {
       
        img.addEventListener('load', () => {
          slide.classList.remove('gif-loading');
          slide.classList.add('gif-loaded');
        });

        img.addEventListener('error', () => {
          slide.classList.remove('gif-loading');
          slide.classList.add('gif-error');
          console.error('Failed to load GIF:', img.src);
        });
      }
    });
  }

  function attachGifHandlers() {
    const overlay = document.querySelector(CONFIG.overlaySelector);
    const container = document.querySelector(CONFIG.containerSelector);
    const slides = document.querySelectorAll(CONFIG.slideSelector);

    if (!overlay || !container) {
      console.warn('Overlay or container not found');
      return;
    }

    if (!slides.length) {
      console.warn('No slides found');
      return;
    }

    console.log('Attaching handlers to', slides.length, 'slides');

    function showLoader() {
      const loader = document.createElement('div');
      loader.className = 'gif-modal-loader';
      loader.innerHTML = `
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      `;
      container.innerHTML = '';
      container.appendChild(loader);
    }

    function openGif(gifUrl) {
      if (!gifUrl) {
        console.warn('No GIF URL provided');
        return;
      }

      console.log('Opening GIF:', gifUrl);

   
      showLoader();
      overlay.classList.remove('hidden');
      document.body.classList.add('no-scroll');

    
      const img = document.createElement('img');
      img.alt = 'Product GIF';
      img.style.cssText = 'width:100%;height:100%;border-radius:8px;object-fit:contain;opacity:0;transition:opacity 0.3s ease;';

      img.onload = () => {
        console.log('GIF loaded successfully');
        container.innerHTML = '';
        container.appendChild(img);
    
        setTimeout(() => {
          img.style.opacity = '1';
        }, 10);
      };

      img.onerror = () => {
        console.error('Failed to load GIF in modal');
        container.innerHTML = `
          <div class="gif-error-message">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <p>Failed to load image</p>
            <button class="retry-button" onclick="this.closest('.video-overlay').classList.add('hidden')">Close</button>
          </div>
        `;
      };

      img.src = gifUrl;
    }

    function closeGif() {
      console.log('Closing GIF modal');
      overlay.classList.add('hidden');
      container.innerHTML = '';
      document.body.classList.remove('no-scroll');
    }

  
    slides.forEach((slide, index) => {
      slide.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        const gifUrl = this.dataset.mediaUrl;
        console.log('Slide', index, 'clicked, URL:', gifUrl);
        
        if (gifUrl) {
          openGif(gifUrl);
        } else {
          console.warn('No media URL found on slide', index);
        }
      });
    });


    const closeBtn = document.querySelector(CONFIG.closeButtonSelector);
    if (closeBtn) {
      closeBtn.addEventListener('click', closeGif);
    } else {
      console.warn('Close button not found');
    }

 
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeGif();
      }
    });


    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.classList.contains('hidden')) {
        closeGif();
      }
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGifCarousel);
  } else {
    initGifCarousel();
  }
})();